// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { User } from '@interfaces/user.interfaces';
import { UserService } from '@services/user.service';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'src/app/login/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class UserResolver implements Resolve<User> {
    constructor(
        private authService: AuthService,
        private userService: UserService
    ) {}

    resolve(): Observable<User> {
        return this.authService.isAuthenticated().pipe(switchMap((isAuthenticated) => (isAuthenticated ? this.userService.getUser$base() : of(null))));
    }
}
